import { IRequestLookupRequest as _IRequestLookupRequest } from './IRequestLookupRequest';
import { IRequestLookupFilters as _IRequestLookupFilters } from './IRequestLookupFilters';

export type IRequestLookupFilters = _IRequestLookupFilters;
export type IRequestLookupRequest = _IRequestLookupRequest;

export { RequestLookupType } from './RequestLookupType';